import { render, staticRenderFns } from "./UpgradeVersion.vue?vue&type=template&id=fe48c7b4"
import script from "./UpgradeVersion.vue?vue&type=script&lang=js"
export * from "./UpgradeVersion.vue?vue&type=script&lang=js"
import style0 from "./UpgradeVersion.vue?vue&type=style&index=0&id=fe48c7b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports